export default (blobType) => {
    if(['png','jpg','jpeg'].includes(blobType)){
        return `image/${blobType}`
    }
    if(blobType==='wav') return 'audio/wav'
    if(blobType==='pdf') return 'application/pdf'
    throw Error('Unknown file type!')
}